import axiosInstance from './api';

/**
 * API service for managed device types
 */
export const managedDeviceTypesApi = {
  /**
   * Get all device types
   */
  getAll: async (includeInactive = false) => {
    const params = includeInactive ? { includeInactive: true } : {};
    const response = await axiosInstance.get('/managed-device-types', { params });
    return response.data;
  },

  /**
   * Get device type by ID
   */
  getById: async (id) => {
    const response = await axiosInstance.get(`/managed-device-types/${id}`);
    return response.data;
  },

  /**
   * Get device type by slug
   */
  getBySlug: async (slug) => {
    const response = await axiosInstance.get(`/managed-device-types/slug/${slug}`);
    return response.data;
  },

  /**
   * Get kinds for a specific device type
   */
  getKindsByTypeSlug: async (typeSlug) => {
    const response = await axiosInstance.get(`/managed-device-types/${typeSlug}/kinds`);
    return response.data;
  },

  /**
   * Create new device type
   */
  create: async (data) => {
    const response = await axiosInstance.post('/managed-device-types', data);
    return response.data;
  },

  /**
   * Update device type
   */
  update: async (id, data) => {
    const response = await axiosInstance.patch(`/managed-device-types/${id}`, data);
    return response.data;
  },

  /**
   * Delete device type
   */
  delete: async (id) => {
    await axiosInstance.delete(`/managed-device-types/${id}`);
  }
};

export default managedDeviceTypesApi;